import { gql } from '@apollo/client';

export const GET_ALL_CALLS = gql`
	query GetAllCalls(
		$page: Int!
		$limit: Int!
		$sort: [SortInput]
		$filters: CallFilterInput
	) {
		calls(
			pagination: { page: $page, limit: $limit }
			sort: $sort
			filters: $filters
		) {
			items {
				id
				externalId
				company {
					id
					gorkoId
					name
					isGorkoCommission
					isGorkoAbonent
					isGorkoHidden
					isGorkoDeleted
				}
				createdBy {
					id
					gorkoId
					name
				}
				createdAt
				updatedAt
			}
			pagination {
				currentPage
				totalPages
				totalCount
			}
		}
	}
`;
